import { inject, Injectable, Provider } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { Role } from '@models';

import { PORTAL_ROLE } from '../tokens/env.token';

export function formatPortalTitle(role: Role, suffix?: string): string {
  const portalName = brandedPortalName(role);
  return suffix ? `${portalName} | ${suffix}` : portalName;
}

function brandedPortalName(role: Role): string {
  switch (role) {
    case 'Provider':
      return 'iCareDx Provider Portal';
    case 'Patient':
      return 'iCareDx Patient Portal';
    default:
      throw new Error(`Portal title branding is not defined for ${role}.`);
  }
}

@Injectable()
export class PortalTitleStrategy extends TitleStrategy {
  private readonly title = inject(Title);
  private readonly portalRole = inject(PORTAL_ROLE);

  override updateTitle(snapshot: RouterStateSnapshot): void {
    this.title.setTitle(
      formatPortalTitle(this.portalRole, this.buildTitle(snapshot))
    );
  }
}

export function providePortalTitle(): Provider {
  return { provide: TitleStrategy, useClass: PortalTitleStrategy };
}
